import { render } from "./DealsSection.vue?vue&type=template&id=4a251e58&ts=true"
import script from "./DealsSection.vue?vue&type=script&lang=ts"
export * from "./DealsSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__